// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Wrapper = styled.div`
  padding-left: 16px;
  border-left: 1px solid ${props => props.theme.indenter};
`;
